import React, {useCallback, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {ContattaciStyle} from "../../../../styles/pages/contact/ContattaciStyle";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import HideAppBar from "../../../widgets/header/HideAppBar";
import clsx from "clsx";
import {
	Button,
	Card,
	CardActionArea,
	CardActions,
	CardContent,
	CardHeader, Chip,
	Container,
	Grid,
	Paper,
	TextField,
	Tooltip,
	Typography
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import moment from "moment";

const AllIstitutiPage = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	const [value, setValue] = useState("");
	const [scuole, setScuole] = useState([]);
	
	function downloadBlob(content, filename, contentType) {
		// Create a blob
		const blob = new Blob([content], {type: contentType});
		const url = URL.createObjectURL(blob);
		
		// Create a link to download it
		const pom = document.createElement('a');
		pom.href = url;
		pom.setAttribute('download', filename);
		pom.click();
	}
	
	const scaricaExcel = useCallback(() => {
		let csv = "ID,Scuola indirzzo,Scuola email,Scuola nome,Scuola telefono 1,Scuola telefono 2," +
			"Referente nome,Referente cognome,Referente codice fiscale,Referente cellulare,Referente email," +
			"Progetto ID 1,Progetto nome 1,Progetto descrizione 1,Progetto tag 1,Progetto link 1," +
			"Progetto ID 2,Progetto nome 2,Progetto descrizione 2,Progetto tag 2,Progetto link 2," +
			"Progetto ID 3,Progetto nome 3,Progetto descrizione 3,Progetto tag 3,Progetto link 3\n";
		
		scuole.forEach(scuola => {
			csv += scuola.id + ',' + scuola.indirizzo?.replaceAll(',', '-') + ',' + scuola?.mail + ',' + scuola.nome + ',' + scuola?.telefono1 + ',' + scuola?.telefono2 + ',' +
				scuola?.referente?.nome + ',' + scuola?.referente?.cognome + ',' + scuola?.referente?.codF + ',' + scuola?.referente?.cell + ',' + scuola?.referente?.email + ',' +
				(
					scuola.progetti && scuola.progetti.length > 0 ?
						scuola.progetti.map(progetto => progetto?.id + ',' + progetto?.nome + ',' + progetto?.descrizione?.replaceAll(',', '-') + ',' + progetto?.tag?.replaceAll(',', '-') + ',' + progetto?.link) :
						''
				);
			csv += '\n';
		})
		
		downloadBlob(csv, `progetto_scuole_${moment(new Date()).format('DD_MM_YYYY__HH_mm')}.csv`, 'text/csv;charset=utf-8;')
	}, [scuole])
	
	useEffect(() => {
		axios
			.get('/ocean-scuole-api/API/auth/getCompanies', getConfig())
			.then((res) => {
				if (res.status !== 226) {
					setScuole(res.data);
				}
			})
	}, [])
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Tutte le scuole"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardHeader
									title={<Typography variant={"h6"}><b>Tutte le scuole</b></Typography>}
									subheader={"Visualizza tutte le scuole iscritte"}
								/>
								<CardContent style={{flexGrow: 1}}>
									<Grid container spacing={3}>
										<Grid item xs={12}>
											<Paper className={clsx(classes.roundBorder)} component={"section"}>
												<TextField
													placeholder={"Cerca per nome dell' istituto"}
													value={value}
													onChange={event => setValue(event.target.value)}
													autoFocus={true}
													fullWidth={true}
													variant={"outlined"}
													InputProps={{
														startAdornment: <InputAdornment position="start">
															<Tooltip title={"Cerca"}>
																<IconButton color="inherit" size="large">
																	<SearchTwoToneIcon/>
																</IconButton>
															</Tooltip>
														</InputAdornment>,
														classes: {notchedOutline: contattaciClasses.noBorder}
													}}
												/>
											</Paper>
										</Grid>
										<Grid item xs={12} className={classes.flexStart}>
											
											{
												scuole.length === 0 && <p>Non ci sono scuole...</p>
											}
											
											{
												scuole
													.filter(item => item.nome.toUpperCase().includes(value.toUpperCase()) || value.toUpperCase().includes(item.nome.toUpperCase()))
													.map((scuola, index) => {
														return (
                                                            <Card key={index}
															      className={clsx(classes.roundBorder, classes.margin1, classes.classActionCardNoHeight)}>
                                                                <Tooltip title={"Clicca per visualizzare lo stato degli alunni e dei docenti"}>
																	<CardActionArea>
																		<CardHeader
																			title={<Typography variant={"subtitle1"}><b>{scuola?.nome}</b></Typography>}
																		/>
																		<CardContent style={{
																			marginTop: 0,
																			paddingTop: 0
																		}}>
																			<Grid container spacing={2} alignContent={"flex-start"} alignItems={"flex-start"}
																			      justifyContent={"flex-start"}>
																				<Grid item xs={12}>
																					<Typography variant={"body2"}>
																						{scuola?.indirizzo}<br/>
																						cell1: <i>{scuola?.telefono1}</i><br/>
																						cell2: <i>{scuola?.telefono2}</i><br/>
																						mail: <i>{scuola?.mail}</i><br/><br/>
																						<b>Referente: {scuola?.referente?.nome + " " + scuola?.referente?.cognome}</b>
																					</Typography>
																				</Grid>
																				<Grid item xs={12}>
																					{
																						scuola?.progetti?.length === 0 && <p>Non ha ancora progetti</p>
																					}
																					{
																						scuola?.progetti.map(progetto => {
																							return <Chip key={progetto.id} label={progetto.nome} style={{margin: 2}}
																							             onClick={() => window.open(progetto.link, '_blank')?.focus()}/>
																						})
																					}
																				</Grid>
																			</Grid>
																		</CardContent>
																	</CardActionArea>
																</Tooltip>
                                                            </Card>
                                                        );
													})
											}
										
										</Grid>
									</Grid>
								</CardContent>
								<CardActions className={classes.flexRight}>
									<Tooltip title={"Scarica file csv"}>
										<Button size={"small"} variant={"contained"} disableElevation color={"primary"}
										        className={classes.roundButton} onClick={scaricaExcel}>
											<b>Scarica excel</b>
										</Button>
									</Tooltip>
								</CardActions>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
};

export default React.memo(AllIstitutiPage);
